import {
    CLEAR_VENDOR_FORGOT_RESPONSE,
    VENDOR_CONFIRM_RESET_TOKEN_REQUEST,
    VENDOR_CONFIRM_RESET_TOKEN_SUCCESS,
    VENDOR_FORGOT_PASSWORD_REQUEST,
    VENDOR_FORGOT_PASSWORD_SUCCESS,
    VENDOR_RESET_PASSWORD_REQUEST,
    VENDOR_RESET_PASSWORD_SUCCESS,
} from "./type";

const initialState = {
    forgotPassApiResponse: null,
    confirmToken: null,
    resetPassword: null,
    error: null,
    loading: false,
};

const VendorForgotReducer = (state = initialState, action) => {
    switch (action.type) {
        case VENDOR_FORGOT_PASSWORD_REQUEST:
            return {
                ...state,
                forgotPassApiResponse: null,
                loading: true,
                error: null,
            };
        case VENDOR_FORGOT_PASSWORD_SUCCESS:
            return {
                ...state,
                forgotPassApiResponse: action.payload,
                loading: false,
            };

        case VENDOR_CONFIRM_RESET_TOKEN_REQUEST:
            return {
                ...state,
                confirmToken: null,
                loading: true,
                error: null,
            };
        case VENDOR_CONFIRM_RESET_TOKEN_SUCCESS:
            return {
                ...state,
                confirmToken: action.payload,
                loading: false,
            };

        case VENDOR_RESET_PASSWORD_REQUEST:
            return {
                ...state,
                resetPassword: null,
                loading: true,
                error: null,
            };
        case VENDOR_RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                resetPassword: action.payload,
                loading: false,
            };

        case CLEAR_VENDOR_FORGOT_RESPONSE:
            return {
                ...state,
                forgotPassApiResponse: null,
                resetPassword: null,
            };
        default:
            return state;
    }
};

export default VendorForgotReducer;
